import { Component, OnDestroy, OnInit } from '@angular/core';
import { DashboardService } from '../../../../service/events/dashboard.service';
import { Router } from '@angular/router';
import { TareasApiService } from '../../../../service/api/tareas-api.service';
import { Utils } from '../../../../common/utils';
import { RequestHandler } from '../../../../service/OffService/request-handler';
import { Filtering } from '../../../../service/filtering/filtering';
import { BaseView } from '../../../base-view';
import moment from 'moment';
import { TreeNode } from 'primeng/api';
import { ColInterface } from 'src/app/common/components/common-list-table/col.interface';
import { ColStylesInterface } from 'src/app/common/components/common-list-table/col-styles.interface';
import { FertirrigacionEnvironmentDefinition } from './environment-variables';
import { FormType } from 'src/app/common/components/reactive-form-builder/interfaces/form.interface';
import { createCsv } from 'src/app/common/components/reactive-form-builder/export/createCsv';
import { FertirrigacionFormDefinition } from './fertirrigacion-form/form-control/form-definition';
import { FertirrigacionModel } from 'src/app/models/tareas/fertirrigacion.model';
import { StorageManager } from 'src/app/common/storage-manager.class';

moment.locale('es');
@Component({
    selector: 'app-fertirrigacion',
    standalone: false,
    templateUrl: './fertirrigacion.component.html',
    styleUrls: ['./fertirrigacion.component.scss']
})
export class FertirrigacionComponent extends BaseView<FertirrigacionModel> implements OnInit, OnDestroy {
    public years = [
        { label: '...', value: 0 },
    ];

    public form: FertirrigacionFormDefinition | null = null;

    public env: FertirrigacionEnvironmentDefinition = new FertirrigacionEnvironmentDefinition();

    public hiddenButtonDelete = false;

    public showButtonDuplicate = true;

    public filter: Filtering<FertirrigacionModel> = new Filtering<FertirrigacionModel>();

    public getRequest: RequestHandler<FertirrigacionModel[]> = this.tareasApi.fertirrigacion.GET;

    public deleteRequest: RequestHandler<FertirrigacionModel> = this.tareasApi.fertirrigacion.DELETE;

    public pathToForm = 'crear-fertirrigacion';

    public menuItemId = 'fertirrigacion';

    public btnAnadir = 'Añadir Riego';

    public receta: FertirrigacionModel = {};

    public override canShow: Record<string, boolean> = {};

    public override model: FertirrigacionModel = {};

    public cols: ColInterface[] = [

        {
            field: 'cliente_nombre',
            header: this.env.clienteName,
            filter: '',
            visible: this.env.hasClients && this.env.userCanSeeClientes && !this.env.showTareasMto
        },
        {
            field: 'finca',
            header: this.env.fincaName
        },
        {
            field: 'sectores_nombres',
            header: this.env.sectoresName,
            visible: !this.env.showTareasMto
        },
        {
            field: 'parcelas_nombres',
            header: this.env.parcelasName,
            visible: !this.env.showTareasMto
        },
        {
            field: 'fecha',
            header: 'Fecha',
        },
        {
            field: 'volumen_riego',
            header: 'Volumen Riego',
        },
        {
            field: 'n_agua',
            header: 'N en agua',
        },
        {
            field: 'aportacion_teorica_nitrogeno',
            header: 'Aportación Teórica de Nitrogeno',
        },
    ];

    constructor(public tareasApi: TareasApiService,
        private readonly dashboardEvents: DashboardService,
        public dashboard: DashboardService,
        private readonly router: Router
    ) {
        super(dashboardEvents, tareasApi.fertirrigacion.GET);
    }

    ngOnInit(): void {
        this.dashboardEvents.setSubmenuItem('tareas', 'fertirrigacion');
    }

    public globalConditionalStyle(_value: string, _col: ColInterface): ColStylesInterface {
        return { textAlign: 'center' };
    }

    public globalVisualTransform(value: string, col: ColInterface, row: TreeNode<FertirrigacionModel>): string {
        const fertirrigacion = row.data as FertirrigacionModel;

        if (col.field === 'documento_aplicacion') {
            return fertirrigacion.documento_aplicacion === 1 ? 'Sí' : 'No';
        }

        if (col.field === 'parcelas_nombres' || col.field === 'sectores_nombres' || col.field === 'cultivo') {
            const str = Utils.replaceAll(Utils.replaceAll((fertirrigacion[col.field]?.toString() || ''), '- ', ''), '\n', '\n, ');
            value = str.substring(0, str.length - 2);
            return (value.length > 20) ? value.slice(0, 20 - 1) + '…' : value;
        }

        if (col.field === 'aportacion_teorica_nitrogeno') {
            const num = parseFloat(value);
            return isNaN(num) ? value : Utils.decimalFormat(num.toString(), 4, '.', ',', 3);
        }

        return value;
    }

    public add(): void {
        if (this.env.hasClients && !StorageManager.getClient() && this.env.userCanSeeClientes) {
            this.dashboard.openClientDialog();
        } else {
            this.router.navigate(['dashboard', this.pathToForm]);
        }
    }

    public edit(data: FertirrigacionModel): void {
        this.router.navigate(['dashboard', 'editar-fertirrigacion', data.id]);
    }

    public duplicate(data: FertirrigacionModel): void {
        this.router.navigate(['dashboard', 'duplicar-fertirrigacion', data.id]);
    }


    public override show(modal: string, data: FertirrigacionModel): void {
        this.model = data;

        super.show(modal, this.model);

        const formType = modal === 'delete' ? +FormType.DELETION : +FormType.INFORMATIVE;

        this.form = new FertirrigacionFormDefinition(formType, data as Record<string, string>, null);
    }

    public override hide(modal: string): void {
        this.model = {};
        this.canShow[modal] = false;
    }

    public override ngOnDestroy(): void {
        Utils.unsuscribe([
            this.tareasApi.fertirrigacion.GET
        ]);
    }

    public downloadCsv(): void {
        this.form = new FertirrigacionFormDefinition(
            +FormType.EXPORT,
            this.filtering.value as unknown as Record<string, string>,
            null
        );
        const csvContent = createCsv(this.form.fieldNames, this.form.fieldLabels, this.filtering.value as FertirrigacionModel[]);
        const csvLink = document.getElementById('csvLink') as HTMLAnchorElement;

        csvLink.download = this.form.formFields.name + '.csv';
        csvLink.href = encodeURI(csvContent);
        csvLink.click();
    }
}
